import { IApiResponse, IFeatureFlagsResponse } from "@miplatform/types";
import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_TENANT_CONFIG = `${SUBSCRIPTION_SERVICE}/tenant-config`;

export const tenantConfig = {
  getFeatureFlags: async (): IApiResponse<IFeatureFlagsResponse> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/feature-flags`,
      method: "get",
    });
    return apiRequest(options);
  },
};
